import React from 'react';
import { Images } from '../app-constants';
import ImageIcon from './images/image-icon';

const InfoCircle = () => (
  <ImageIcon src={Images.InfoCircle} alt="sh-logo-icon/" />
);

export default InfoCircle;
